var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 85.48",
    style: {
      enableBackground: "new 0 0 122.88 85.48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9933",
    d: "M6.71,0h109.46c3.7,0.02,6.71,3.05,6.71,6.75v71.98c0,3.71-3.04,6.75-6.75,6.75l-109.42,0 C3.02,85.46,0,82.43,0,78.73V6.75C0,3.05,3.01,0.02,6.71,0L6.71,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "0,28.49 122.88,28.49 122.88,56.99 0,56.99 0,28.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#128807",
    d: "M0,56.99h122.88v21.74c0,3.71-3.04,6.75-6.75,6.75l-109.42,0C3.02,85.46,0,82.43,0,78.73V56.99L0,56.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000088",
    d: "M72.84,42.74c0-6.3-5.1-11.4-11.4-11.4s-11.4,5.1-11.4,11.4c0,6.29,5.1,11.4,11.4,11.4 S72.84,49.04,72.84,42.74L72.84,42.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.41,42.74c0-5.51-4.46-9.97-9.97-9.97s-9.97,4.46-9.97,9.97c0,5.51,4.46,9.97,9.97,9.97 S71.41,48.25,71.41,42.74L71.41,42.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000088",
    d: "M63.43,42.74c0-1.1-0.89-2-1.99-2s-1.99,0.89-1.99,2c0,1.1,0.89,1.99,1.99,1.99S63.43,43.84,63.43,42.74 L63.43,42.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000088",
    d: "M71.82,44.11c0.04-0.27-0.16-0.52-0.43-0.56c-0.27-0.04-0.52,0.16-0.56,0.43s0.16,0.52,0.43,0.56 C71.54,44.57,71.79,44.38,71.82,44.11L71.82,44.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000088",
    points: "61.44,52.71 61.78,46.73 61.44,43.88 61.1,46.73 61.44,52.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.11,46.75c0.11-0.25-0.02-0.55-0.27-0.65c-0.25-0.11-0.55,0.02-0.65,0.27c-0.11,0.25,0.02,0.55,0.27,0.65 C70.72,47.12,71.01,47,71.11,46.75L71.11,46.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.86,52.37 60.74,46.68 61.15,43.84 60.08,46.51 58.86,52.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75,49.12c0.17-0.22,0.13-0.53-0.09-0.7c-0.22-0.17-0.53-0.13-0.7,0.09c-0.17,0.22-0.13,0.53,0.09,0.7 C69.27,49.38,69.58,49.33,69.75,49.12L69.75,49.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.45,51.38 59.74,46.37 60.87,43.73 59.15,46.02 56.45,51.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.81,51.05c0.22-0.17,0.26-0.48,0.09-0.7c-0.17-0.22-0.48-0.26-0.7-0.09c-0.22,0.17-0.26,0.48-0.09,0.7 C67.28,51.17,67.6,51.22,67.81,51.05L67.81,51.05z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.39,49.79 58.86,45.8 60.63,43.55 58.38,45.32 54.39,49.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.45,52.42c0.25-0.11,0.38-0.4,0.27-0.65c-0.11-0.25-0.4-0.38-0.65-0.27c-0.25,0.1-0.38,0.4-0.27,0.65 C64.9,52.4,65.19,52.52,65.45,52.42L65.45,52.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.8,47.73 58.16,45.03 60.45,43.31 57.81,44.44 52.8,47.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.81,53.12c0.27-0.04,0.46-0.29,0.43-0.56c-0.04-0.27-0.29-0.46-0.56-0.43c-0.27,0.04-0.46,0.29-0.43,0.56 C62.28,52.97,62.53,53.16,62.81,53.12L62.81,53.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.81,45.32 57.68,44.1 60.34,43.04 57.5,43.44 51.81,45.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.07,53.12c0.27,0.04,0.52-0.16,0.56-0.43c0.04-0.27-0.16-0.52-0.43-0.56c-0.27-0.04-0.52,0.16-0.56,0.43 C59.61,52.84,59.8,53.09,60.07,53.12L60.07,53.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.47,42.74 57.45,43.08 60.3,42.74 57.45,42.4 51.47,42.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.43,52.42c0.25,0.11,0.55-0.02,0.65-0.27s-0.02-0.55-0.27-0.65c-0.25-0.11-0.55,0.02-0.65,0.27 C57.06,52.02,57.18,52.31,57.43,52.42L57.43,52.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.81,40.16 57.5,42.04 60.34,42.45 57.68,41.38 51.81,40.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.06,51.05c0.22,0.17,0.53,0.13,0.7-0.09c0.17-0.22,0.13-0.53-0.09-0.7c-0.22-0.17-0.53-0.13-0.7,0.09 C54.81,50.57,54.85,50.88,55.06,51.05L55.06,51.05z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.8,37.75 57.81,41.04 60.45,42.17 58.16,40.45 52.8,37.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,49.12c0.17,0.22,0.48,0.26,0.7,0.09c0.22-0.17,0.26-0.48,0.09-0.7c-0.17-0.22-0.48-0.26-0.7-0.09 C53.01,48.58,52.96,48.9,53.13,49.12L53.13,49.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.39,35.69 58.38,40.16 60.63,41.94 58.86,39.68 54.39,35.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.76,46.75c0.11,0.25,0.4,0.38,0.65,0.27c0.25-0.11,0.38-0.4,0.27-0.65c-0.11-0.25-0.4-0.38-0.65-0.27 C51.78,46.2,51.66,46.49,51.76,46.75L51.76,46.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.45,34.1 59.15,39.46 60.87,41.75 59.74,39.12 56.45,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,44.11c0.04,0.27,0.29,0.46,0.56,0.43c0.27-0.04,0.46-0.29,0.43-0.56c-0.04-0.27-0.29-0.46-0.56-0.43 C51.21,43.58,51.02,43.83,51.06,44.11L51.06,44.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.86,33.11 60.08,38.98 61.15,41.64 60.74,38.8 58.86,33.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,41.37c-0.04,0.27,0.16,0.52,0.43,0.56c0.27,0.04,0.52-0.16,0.56-0.43c0.04-0.27-0.16-0.52-0.43-0.56 C51.34,40.91,51.09,41.1,51.06,41.37L51.06,41.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.44,32.77 61.1,38.75 61.44,41.6 61.78,38.75 61.44,32.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.77,38.73c-0.11,0.25,0.02,0.55,0.27,0.65c0.25,0.1,0.55-0.02,0.65-0.27c0.11-0.25-0.02-0.55-0.27-0.65 C52.16,38.36,51.87,38.48,51.77,38.73L51.77,38.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.02,33.11 62.14,38.8 61.73,41.64 62.8,38.98 64.02,33.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,36.37c-0.17,0.22-0.13,0.53,0.09,0.7c0.22,0.17,0.53,0.13,0.7-0.09c0.17-0.22,0.13-0.53-0.09-0.7 C53.61,36.11,53.3,36.15,53.13,36.37L53.13,36.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.43,34.1 63.14,39.12 62.01,41.75 63.73,39.46 66.43,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.07,34.43c-0.22,0.17-0.26,0.48-0.09,0.7c0.17,0.22,0.48,0.26,0.7,0.09c0.22-0.17,0.26-0.48,0.09-0.7 S55.28,34.27,55.07,34.43L55.07,34.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.49,35.69 64.02,39.68 62.25,41.94 64.5,40.16 68.49,35.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.43,33.07c-0.25,0.11-0.37,0.4-0.27,0.65c0.11,0.25,0.4,0.38,0.65,0.27c0.25-0.11,0.38-0.4,0.27-0.65 C57.98,33.08,57.69,32.96,57.43,33.07L57.43,33.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.08,37.75 64.72,40.45 62.43,42.17 65.07,41.04 70.08,37.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.07,32.36c-0.27,0.04-0.46,0.29-0.43,0.56c0.04,0.27,0.29,0.46,0.56,0.43c0.27-0.04,0.47-0.29,0.43-0.56 C60.6,32.52,60.35,32.32,60.07,32.36L60.07,32.36z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.07,40.16 65.2,41.38 62.54,42.45 65.38,42.04 71.07,40.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.81,32.36c-0.27-0.04-0.52,0.16-0.56,0.43c-0.04,0.27,0.16,0.52,0.43,0.56c0.27,0.04,0.52-0.16,0.56-0.43 C63.27,32.65,63.08,32.39,62.81,32.36L62.81,32.36z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.41,42.74 65.43,42.4 62.58,42.74 65.43,43.08 71.41,42.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.45,33.07c-0.25-0.11-0.55,0.02-0.65,0.27c-0.11,0.25,0.02,0.55,0.27,0.65c0.25,0.1,0.55-0.02,0.65-0.27 C65.82,33.46,65.7,33.17,65.45,33.07L65.45,33.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.07,45.32 65.38,43.44 62.54,43.04 65.2,44.1 71.07,45.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.81,34.43c-0.22-0.17-0.53-0.13-0.7,0.09c-0.17,0.22-0.13,0.53,0.09,0.7c0.22,0.17,0.53,0.13,0.7-0.09 C68.07,34.91,68.03,34.6,67.81,34.43L67.81,34.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.08,47.73 65.07,44.44 62.43,43.31 64.72,45.03 70.08,47.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75,36.37c-0.17-0.22-0.48-0.26-0.7-0.09s-0.26,0.48-0.09,0.7c0.17,0.22,0.48,0.26,0.7,0.09 C69.87,36.9,69.92,36.58,69.75,36.37L69.75,36.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.49,49.79 64.5,45.32 62.25,43.55 64.02,45.8 68.49,49.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.12,38.73c-0.11-0.25-0.4-0.38-0.65-0.27s-0.38,0.4-0.27,0.65c0.11,0.25,0.4,0.37,0.65,0.27 C71.1,39.28,71.22,38.99,71.12,38.73L71.12,38.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.43,51.38 63.73,46.02 62.01,43.73 63.14,46.37 66.43,51.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.82,41.37c-0.04-0.27-0.29-0.46-0.56-0.43c-0.27,0.04-0.46,0.29-0.43,0.56c0.04,0.27,0.29,0.46,0.56,0.43 C71.67,41.9,71.86,41.65,71.82,41.37L71.82,41.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.02,52.37 62.8,46.51 61.73,43.84 62.14,46.68 64.02,52.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india-flag.752378857cbf2c3de54d2ceae4a09f2b.svg";
export { ForwardRef as ReactComponent };